import { render, staticRenderFns } from "./TutorialText.vue?vue&type=template&id=752110a4&scoped=true"
import script from "./TutorialText.vue?vue&type=script&lang=js"
export * from "./TutorialText.vue?vue&type=script&lang=js"
import style0 from "./TutorialText.vue?vue&type=style&index=0&id=752110a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752110a4",
  null
  
)

export default component.exports